import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import ContentLoading from 'Components/ComponentLibrary/Molecules/ContentLoading';
import { useCommentLayoutContext } from '../../../CommentLayoutProvider';
import Content from './Content';

const Container = () => {
  const { threadCollection, threadCollectionError } = useCommentLayoutContext();

  return (
    <DataContainer
      component={Content}
      loading={!threadCollection}
      loadingError={threadCollectionError}
      skeleton={ContentLoading}
    />
  );
};

export default Container;
